<template>
    <div id="HomeLateralTabs">
        <div class="sections-container">
            <div class="tabs" v-for="(siteType, key) in siteTypes" :key="key" :class="[siteType]">
                <router-link :to="{ name: ROUTER_TAB[siteType], query: { site_type: siteType } }" class="title-link">
                    <img class="title" :src="IMAGES[siteType]" />
                </router-link>
                    
                <div class="tab" :class="{active: isActive(siteType, 'celebrities')}" @click="setTab(siteType, 'celebrities')">
                    <i class="far fa-star"></i>
                    <span>Celebrities</span>
                </div>
    
                <div class="tab" :class="{active: isActive(siteType, 'outstanding')}" @click="setTab(siteType, 'outstanding')">
                    <i class="fas fa-award"></i>
                    <span>{{$t('home2021.outstanding')}}</span>
                </div>
    
                
                <div class="tab" :class="{active: isActive(siteType, 'feeds')}"       @click="setTab(siteType, 'feeds')">
                    <i class="far fa-newspaper"></i>
                    <span>Feed</span>
                </div>
                
                
                <div class="tab" :class="{active: isActive(siteType, 'webstars')}"    @click="setTab(siteType, 'webstars')">
                    <i class="far fa-user"></i>
                    <span>{{$t('header.webstars_short')}}</span>
                </div>
            </div>
        </div>

        <hr />

        <div class="user-container">
            <div class="tabs">
                <template v-if="$auth.ready() && $auth.check()">
                    <router-link class="tab" :to="{ name: 'dashboard'}" >
                        <i class="far fa-user"></i>
                        <span>{{ $t("header.dashboard") }}</span>
                    </router-link>
        
                    <router-link class="tab" :to="{ name: 'subscriptions'}">
                        <i class="fas fa-money-check-alt"></i>
                        <span>{{$t('dashboard.subscriptions.short')}}</span>
                    </router-link>
                </template>

                <a class="tab" v-if="chatUrl" :href="chatUrl">
                    <i class="fas fa-comments"></i>
                    <span>{{$t('chat.room.title')}}</span>
                </a>
                
                <router-link class="tab" :to="{ name: 'support'}">
                    <i class="fas fa-headset"></i>
                    <span>{{$t('footer.items.support.title')}}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import ThemeManager from "../../modules/ThemeManager/ThemeManager.js";
import resources from "../../resources.js";

export default {
    name: 'HomeLateralTabs',
    props: {
        activeTabName: {
            type: String,
            default: null
        }
    },
    data(){
        let isDivasTheme = ThemeManager.isDivasTheme();
        const IMAGES = {
            [ThemeManager.DIVAS_THEME]: '/img/logo2.png',
            [ThemeManager.CHADS_THEME]: '/img/themes/chads/logo2.png'
        };

        const ROUTER_TAB = {
            [ThemeManager.DIVAS_THEME]: 'home',
            [ThemeManager.CHADS_THEME]: 'celebrities'
        };

        return {
            isDivasTheme,
            siteTypes: ThemeManager.themes,
            IMAGES,
            ROUTER_TAB
        }
    },
    computed: {
        // Add computed property to get chatUrl from store
        chatUrl() {
            return this.$store.state.chat_url;
        }
    },
    methods: {
        isActive(siteType, tabName) {
            return this.activeTabName === tabName && this.isDivasTheme === (siteType === ThemeManager.DIVAS_THEME);
        },
        setTab(siteType, tabName){
            ThemeManager.setTheme(siteType);
            this.$emit('setTab', tabName);
        },
    },
    watch: {
        '$store.state.general.site_type': function(value) {
            this.isDivasTheme = ThemeManager.isDivasTheme();
        }
    },
    mounted() {
        const chatEnabled = !!(process.env.VUE_APP_CHAT_ENABLED && process.env.VUE_APP_CHAT_ENABLED === 'true');
        if(chatEnabled) {
            resources.chat.getHomeUrl().then((response) => {
                if (!response.data.success || !response.data.url) return;
                // Use Vuex action to update the store
                this.$store.dispatch('updateChatUrl', response.data.url);
            }).catch(() => null);
        }
    }
}
</script>
<style scoped lang="scss">
@import '../../styles/variables';
@import '../../styles/classes';

hr {
    margin-inline: 1.25em;
}

.tabs {
    flex-direction: column;
    margin-top: 0;
    margin-bottom: 15px;
    margin-inline: auto;
    text-align: left;
    // width: 70%;

    // @media (max-width: 768px) {
        display: flex;
        width: 100%;
        flex-direction: column;
        padding-inline: 1.25em;
    // }

    .title-link {
        width: fit-content;
    }

    .title {
        width: 10em;
    }
    
    .tab {
        width: fit-content;
        line-height: 2;
        font-weight: 600;
        cursor: pointer;
        padding: unset;
        color: var(--pallete_clear_text_color) !important;

        display: block;

        @media (min-width: 768px) and (max-width: 858px) {
            font-size: 0.9em;
            min-width: 130px;            
        }

        i {
            margin-right: 0.75em;
            width: 1.25em;
            text-align: center;
            font-size: 0.75em;
        }

        span {
            font-size: 0.9em;
        }
    }

}

.tabs.divas .tab {
    &.active, &:hover {
        color: $DIVAS-PALLETE_MAIN_COLOR !important;
    }
}

.tabs.chads .tab {
    &.active, &:hover {
        color: $CHAD-PALLETE_MAIN_COLOR !important;
    }
}

.sections-container {
    margin-bottom: 2.5em;
}

.user-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.5em;

    .tab:hover {
        filter: brightness(+50%);
    }
}
</style>
